import React from 'react';
import styled from '@emotion/styled';
import { useQueryParams } from '@css-xp/ppc-utils';
import { OrderPage } from './order-page';
import { SelectCustomerPage } from './select-customer-page';
import { SelectBillingProfilePage } from './select-billing-profile-page';
import { CART_ROUTE_PARAMS } from './constants';

const CartPageContainer = styled.div`
  .page-header-container {
    padding-left: 0;
  }
`;
export const CartPage = () => {
  const query = useQueryParams();
  const customer = query.get(CART_ROUTE_PARAMS.CUSTOMER);
  const billingProfile = query.get(CART_ROUTE_PARAMS.BILLING_PROFILE);
  const content = React.useMemo(() => {
    if (billingProfile) {
      return <OrderPage />;
    }
    if (customer) {
      return <SelectBillingProfilePage />;
    }
    return <SelectCustomerPage />;
  }, [customer, billingProfile]);
  return <CartPageContainer>{content}</CartPageContainer>;
};
